import { render, staticRenderFns } from "./allSessionsList.vue?vue&type=template&id=1dce9f5d&"
import script from "./allSessionsList.vue?vue&type=script&lang=js&"
export * from "./allSessionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports